
import {SetupContext} from "vue";

export default {
  name: "Modal",
  emits: ["update:open"],
  props: {
    open: {
      type: Boolean,
      require: true
    }
  },
  setup(props: any, {emit}: SetupContext) {
    // const {open} = toRefs(props);

    const onClose = () => {
      emit("update:open", false);
    }

    return {
      onClose,
    }
  }
}
